export interface AuthState {
  token: string | any;
  ssoLink: string | any;
  busy?: boolean | any;
}

export const initialState: AuthState = {
  token: undefined,
  ssoLink: null,
  busy: false,
};
